<template>
  <div id="app">
    <div class="wrap full-wrap" style="padding-top: 9.35em;">
      <div class="main-wrap">
        <section class="main">
          <article class="post page">
            <div class="inner">
              <h1 class="text-large">คำถามที่พบบ่อย</h1>
              <div class="panel-group">
                <div class="panel panel-default" v-for="faq in faqInfo" v-bind:key="faq">
                  <div class="panel-heading bg-yellow" style="padding:20px">
                    <h4 class="panel-title">
                      <a data-toggle="collapse" v-bind:href="'#collapse' + faq.id" class="text-gray">
                        คำถาม: {{ faq.question }}
                        <i class="fas fa-angle-down"></i>
                      </a>
                    </h4>
                  </div>
                  <div v-bind:id="'collapse' + faq.id" class="panel-collapse collapse" style="padding:20px">
                    <div class="panel-body">คำตอบ:<br>
                      <div v-html="faq.answer"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </article>
          <div class="border"></div>
        </section>
      </div>
      <!-- /main-wrap -->
    </div>
    <div class="text-center">
      <h1 class="home-sticky-title text-large">
        เข้าชมแล้ว {{ Number(counterInfo.visitors).toLocaleString() }} ครั้ง
      </h1>
    </div>
  </div>
</template>

<script>
export default {
  name: "App",
  data: function () {
    return {
      msg: "Welcome to Your Vue.js App",
      faqInfo: null,
      counterInfo: null
    };
  },
  mounted: function () {
    this.axios
      .get(this.$hostUrl + "TH/php_action/faqAPI.php?action=all")
      .then(response => {
        this.faqInfo = response.data.mainData;
        this.counterInfo = response.data.counter;
      })
      .finally(() => {
        console.log(this.faqInfo);
      });
  }
};
</script>


